import React from "react";
import "./Footer.css";

const Footer = props => (
    <footer className="footer-copyright py-3 text-center text-white fixed-bottom">
        © 2018 Copyright:
        <a className="text-white" href="/"> click-click.com </a>
    </footer>
);

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer/Footer.js